<script>

import NewArticle from "@/views/components/cms/new/NewArticle.vue";

export default {
  name: "ClearUpToolNew",
  components: {
    NewArticle,
  },
}
</script>

<template>
  <NewArticle :category-id="10"></NewArticle>
</template>

<style scoped>

</style>
